import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import {Button, Grid, Typography} from '@mui/material';
import {Formik} from 'formik';
import {useEffect, useRef, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {v4 as uuid} from 'uuid';
import {useAppBar} from '../../components/appBar/appBarContext';
import CustomisedButton from '../../components/button/button';
import CustomisedCardLine from '../../components/card/cardLine';
import CustomisedDatePicker from '../../components/datePicker/datePicker';
import DatePickerComponents from '../../components/datePicker/datePickerComponents';
import CustomisedTextField from '../../components/textField/textField';
import TextPhone from '../../components/textPhone/textPhone';
import CustomisedTitleFont14 from '../../components/title/titleFont14';
import {SendBasicInformation} from '../../models/basicInformations.model';
import {IGetCustomerInfoResponse} from '../../models/customer.model';
import {IGetCustomerInfoForInquiryResponse} from '../../models/loan.model';
import {
    IAddCustomerInfoForInquiryRequest,
    IRefrenceKeyRequest,
} from '../../models/registration.model';
import {
    changeRouteType,
    getpervState,
} from '../../redux/handleBackBtn/handleBackBtnSlice';
import {RootState} from '../../redux/store';
import {getTokenClaims} from '../../services/auth.service';
import {
    addCustomerInfoForInquiry,
    getCustomerInfoForInquiry,
} from '../../services/loan.service';
import {IContainerApp} from '../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import BasicInformationSkeletom from './basicInformationSkeleton';
const BasicInformation = ({referenceKey, setStep, back}: IContainerApp) => {
    const dispatch = useDispatch();
    const {setHeader} = useAppBar();
    const [birthday, setBirthday] = useState<Date>();
    const [postalCode, setPostalCode] = useState('');
    const [selectedCount, setSelectedPart] = useState();
    const [phone, setPhone] = useState<string>();
    const [mobileWidth, setMobileWidth] = useState(window.innerWidth <= 500);
    const [width, setWidth] = useState(window.innerWidth);
    const [isPhoneValid, setPhoneValid] = useState(false);
    const feePaymentType = useSelector(
        (state: RootState) => state.subscriptionPlan
    ).feePaymentType!;
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
        setMobileWidth(window.innerWidth <= 500);
    };
    const yupPostalCodeMax = 10;
    const getPostalCode = (e: any) => {
        setPostalCode(e.target.value);
    };
    const nationalCode = getTokenClaims()?.nationalCode;
    const phoneNumber = getTokenClaims()?.phoneNumber;
    const buttonRef = useRef<any>(null);
    const queryClient = useQueryClient();
    const {profile}: {profile: IGetCustomerInfoResponse} =
        queryClient.getQueryData('PROFILE_INFO')! || {};

    useEffect(() => {
        dispatch(getpervState({prevState: back}));
        dispatch(changeRouteType({routeType: 'parent'}));
        // dispatch(
        //     setHeaderTitle({
        //         header: 'اطلاعات اولیه',
        //         parentRoute: 'basic',
        //     })
        // );
        setHeader('اطلاعات اولیه', 'basicInformation');

        const refrenceKeyRequest = {} as IRefrenceKeyRequest;
        refrenceKeyRequest.referenceKey = referenceKey!;
        GetCustomerInfoForInquiryMutate(refrenceKeyRequest);
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const postalCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupPostalCodeMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const currentSelection = (e: any) => {
        setSelectedPart(
            e.target.value.substring(
                e.target.selectionStart,
                e.target.selectionEnd
            ).length
        );
    };

    const [formInfo, setFormInfo] = useState<SendBasicInformation>({
        birthday: undefined,
        postalCode: undefined,
    } as SendBasicInformation);
    function handleDateChange(event: any, key: string, value: Date) {
        setFormInfo({...formInfo, [key]: value as Date});
        setBirthday(value);
    }

    const handleChangePhone = (e: any) => {
        setPhone(e.target.value);
    };

    const {mutate: AddCustomerInfoForInquiryMutate} = useMutation(
        addCustomerInfoForInquiry,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    setStep(uuid());
                }
            },
        }
    );
    const {mutate: GetCustomerInfoForInquiryMutate, isLoading} = useMutation(
        getCustomerInfoForInquiry,
        {
            onSuccess: (data: IGetCustomerInfoForInquiryResponse) => {
                if (data) {
                    setBirthday(new Date(data.birthDate));
                    setPostalCode(data.postalCode);
                    setPhone(data.phone);
                    setFormInfo({
                        birthday: data.birthDate && new Date(data.birthDate),
                        // birthday: data.birthDate,
                        postalCode: data.postalCode,
                    });
                    const updateUserProfile = {
                        ...profile,
                        profile: {
                            ...profile,
                            birthDate: data.birthDate,
                            mobileNumber: data.mobileNumber,
                            fullName: data.fullName,
                            nationalCode: data.nationalCode,
                        },
                    };
                    queryClient.setQueryData('PROFILE_INFO', updateUserProfile);
                }
            },
        }
    );

    function fromDateToString(date: Date): string {
        date = new Date(+date);
        date.setTime(date.getTime() - date.getTimezoneOffset() * 60000);
        let dateAsString = date.toISOString().substr(0, 19);
        return dateAsString;
    }

    const arrayList = [
        {
            title: (
                <>
                    <BadgeIcon sx={{fontSize: '20px', marginLeft: '5px'}} />
                    کد ملی
                </>
            ),
            value: nationalCode,
        },
        {
            title: (
                <>
                    <PhoneIphoneIcon
                        sx={{fontSize: '20px', marginLeft: '5px'}}
                    />
                    شماره موبایل
                </>
            ),
            value: phoneNumber,
        },
    ];
    if (isLoading) {
        return <BasicInformationSkeletom />;
    } else {
        return (
            <div className="container-height-drawer">
                <div className="content-container">
                    <div
                        className="drawer-content"
                        style={{margin: 'auto', width: '98%'}}
                    >
                        <Typography style={{paddingBottom: '0.6rem'}}>
                            <CustomisedTitleFont14 title={'اطلاعات کاربر'} />
                        </Typography>
                        <CustomisedCardLine itemList={arrayList} />
                        <Formik
                            initialValues={
                                {} as IAddCustomerInfoForInquiryRequest
                            }
                            onSubmit={(
                                values: IAddCustomerInfoForInquiryRequest
                            ) => {
                                values.referenceKey = referenceKey!;
                                values.birthDate = fromDateToString(birthday!);
                                values.postalCode = postalCode;
                                if (phone != undefined && phone != null) {
                                    let phoneTrimed = phone!.replace(/\s/g, '');
                                    values.phone = phoneTrimed!.replace(
                                        /_|\-/,
                                        ''
                                    );
                                }
                                AddCustomerInfoForInquiryMutate({
                                    ...values,
                                    feePaymentType: feePaymentType,
                                });
                            }}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleBlur,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div
                                        className="centerClass"
                                        style={{
                                            paddingTop: '1.9rem',
                                            paddingLeft: '0px ',
                                        }}
                                    >
                                        <Grid
                                            container
                                            className="row"
                                            spacing={2}
                                            style={{
                                                alignItems: 'center',
                                                width: '100%',
                                                margin: 'auto',
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingLeft: '0px',
                                                }}
                                            >
                                                {mobileWidth ? (
                                                    <CustomisedDatePicker
                                                        value={
                                                            formInfo.birthday as Date
                                                        }
                                                        label={'تاریخ تولد'}
                                                        placeHolder="تاریخ تولد"
                                                        helperText={
                                                            'تاریخ تولد'
                                                        }
                                                        // error={}
                                                        onChange={(
                                                            value: any
                                                        ) =>
                                                            handleDateChange(
                                                                null,
                                                                'brithDate',
                                                                value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <DatePickerComponents
                                                        value={
                                                            formInfo.birthday as Date
                                                        }
                                                        label={'تاریخ تولد'}
                                                        onChange={(
                                                            value: any
                                                        ) => {
                                                            handleDateChange(
                                                                null,
                                                                'brithDate',
                                                                value
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingLeft: '0px',
                                                }}
                                            >
                                                <CustomisedTextField
                                                    autoFocus={false}
                                                    helperText={
                                                        !touched.postalCode
                                                            ? errors.postalCode
                                                            : ''
                                                    }
                                                    error={
                                                        !touched.postalCode &&
                                                        Boolean(
                                                            errors.postalCode
                                                        )
                                                    }
                                                    label="کد پستی"
                                                    placeholder={'98765432198'}
                                                    required={true}
                                                    inputProps={{
                                                        type: 'number',
                                                        inputMode: 'numeric',
                                                        lang: 'en',
                                                    }}
                                                    value={postalCode}
                                                    onChange={getPostalCode}
                                                    name="postalCode"
                                                    id="postalCode"
                                                    onKeyDown={
                                                        postalCodeHandleKeyDown
                                                    }
                                                    onSelect={currentSelection}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    paddingTop: '1.9rem',
                                                    paddingLeft: '0px',
                                                }}
                                            >
                                                <TextPhone
                                                    className={
                                                        'shadowTextField'
                                                    }
                                                    id="phone"
                                                    name="phone"
                                                    label={'تلفن ثابت'}
                                                    value={phone || ''}
                                                    placeHolder={'021-00000000'}
                                                    onChange={handleChangePhone}
                                                    onBlur={handleBlur}
                                                    onSelect={currentSelection}
                                                    setValid={setPhoneValid}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                    <div className="pt-5 button-container">
                                        <Button
                                            title={'ادامه'}
                                            type="submit"
                                            ref={buttonRef}
                                            style={{display: 'none'}}
                                        ></Button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click();
                                }
                            }}
                            title=" ادامه"
                            type="button"
                            disable={
                                (birthday !== birthday) !== undefined &&
                                postalCode !== null &&
                                postalCode !== undefined &&
                                postalCode !== '' &&
                                phone !== null &&
                                phone !== undefined &&
                                phone !== '' &&
                                phone.length === 11 &&
                                isPhoneValid
                                    ? false
                                    : true
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
};

export default BasicInformation;
